interface Deferred {
  promise: Promise<void>;
  resolve: () => void;
  reject: (reason: unknown) => void;
}

let deferred: Deferred | null = null;

/**
 * Held requests wait here while the reauth modal is open. Every waiter shares one promise, so a single
 * successful password confirmation releases all of them.
 */
export const waitForReauth = (): Promise<void> => {
  if (!deferred) {
    let resolve!: () => void;
    let reject!: (reason: unknown) => void;
    const promise = new Promise<void>((res, rej) => {
      resolve = res;
      reject = rej;
    });
    // The rejection is delivered to the waiters; this stops it also counting as unhandled when none remain.
    promise.catch(() => undefined);
    deferred = { promise, resolve, reject };
  }
  return deferred.promise;
};

export const resolveReauthWaiters = () => {
  const current = deferred;
  deferred = null;
  current?.resolve();
};

export const rejectReauthWaiters = (reason: unknown = 'reauth-abandoned') => {
  const current = deferred;
  deferred = null;
  current?.reject(reason);
};
